// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.portalanalytics.enums.AnalyticsBucketType

export enum AnalyticsBucketType {
  CONSOLIDATED = 'CONSOLIDATED',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
}

export const AnalyticsBucketType_values = [
  AnalyticsBucketType.CONSOLIDATED,
  AnalyticsBucketType.DAILY,
  AnalyticsBucketType.MONTHLY,
] as const;
